import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = ["href"];
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'Link',
    props: {
        to: null,
        external: null,
        open: { type: Boolean, default: false }
    },
    setup(__props) {
        const hostname = ref(window.location.origin);
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (__props.external)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "external-link",
                    href: __props.external,
                    target: "_blank"
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 8, _hoisted_1))
                : (__props.open)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: hostname.value + '/#' + __props.to,
                        target: "_blank"
                    }, [
                        _renderSlot(_ctx.$slots, "default")
                    ], 8, _hoisted_2))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: __props.to
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3
                    }, 8, ["to"]));
        };
    }
});
